import { render, staticRenderFns } from "./ContractAbi.vue?vue&type=template&id=130fc31c"
import script from "./ContractAbi.vue?vue&type=script&lang=js"
export * from "./ContractAbi.vue?vue&type=script&lang=js"
import style0 from "./ContractAbi.vue?vue&type=style&index=0&id=130fc31c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports